<template>
  <div v-loading="pageLoad||cardALoad||cardBLoad" class="portlet">
    <div class="content">
        <div class="img-list">
            <img v-loading="cardALoad" :src="cardAUrl" @click="uploadImg(1)">
            <img v-loading="cardBLoad" :src="cardBUrl" @click="uploadImg(2)">
             <input ref="idcardz" style="visibility: hidden;" type="file" @change="uploadIdCardA($event)"/>
             <input ref="idcardf" style="visibility: hidden;" type="file" @change="uploadIdCardB($event)"/>

        </div>
        <div class="id-info">
            <div class="item">
                <span class="title">姓名：</span>
                <span class="ver-info">{{infoObj.nickname}}</span>
            </div>
            <div class="item">
                <span class="title">性别：</span>
                <span class="ver-info">{{infoObj.sex}}</span>
            </div>
            <div class="item">
                <span class="title">身份证号：</span>
                <span class="ver-info">{{infoObj.id_number}}</span>
            </div>
            <div class="item">
                <span class="title"><span style="color:red">*</span>邮箱：</span>
                <input v-model="email" style="height:29px" class="ver-info" placeholder="请输入邮箱">
            </div>
        </div>
    </div>
    <div class="step-btn" @click="next">下一步
        <i class="fa icon-arrow-right"/>
    </div>
  </div>
</template>
<script>
export default {
    props:{
        token:{
            type:String,
            default:() => '',
        }
    },
    data() {
        return {
            email:'',
            pageLoad: false,
            cardALoad: false,
            cardBLoad: false,
            cardAUrl: require('../../assets/idcardf.png'),
            cardBUrl: require('../../assets/idcardz.png'),
            infoObj:{
                nickname:'身份证自动识别',
                sex:'身份证自动识别',
                id_number:'身份证自动识别',
                address:'',
                token: '',
            },
            uploadCardASuccess:false,
            uploadCardBSuccess:false,
        }
    },
    methods: {
        uploadImg(type){
            if(type === 1){
                this.$refs.idcardz.click();
            }else{
                this.$refs.idcardf.click();
            }
        },
        async next(){
            this.infoObj.token = this.token;
            if(!this.uploadCardASuccess){
                this.$toast('请上传身份证正面照');
                return false;
            }else if(!this.uploadCardBSuccess){
                this.$toast('请上传身份证反面照');
                return false;
            }
            if(this.email === ''){
                this.$toast('请输入邮箱信息');
                return false;
            }
            this.pageLoad = true;
            try {
                const headers = {headers: {
                    'Authorization': this.token
                }};
                this.infoObj.email = this.email;
                const res = await this.$http.post('/api/user/updateUserInfo?token='+this.token,this.infoObj,headers);
                this.pageLoad = false;
                if(res){
                    localStorage.setItem('tem_ifm_token',this.token);
                    this.$emit('changeStep',3);
                }
            } catch (error) {
                this.pageLoad = false;
                this.$toast(error.message||'请求失败');
            }
            
        },
        async uploadIdCardA(e){
            const imgFile = e.target.files[0];
            const formData = new FormData();
            formData.append('file', imgFile);
            formData.append('is_ocr', 1);
            this.cardALoad = true;
            try {
                const res = await this.$http.post('/api/user/uploadIdCard',formData);
                this.cardALoad = false;
                if(res){
                    this.infoObj.nickname = res.name;
                    this.infoObj.sex = res.sex;
                    this.infoObj.address = res.addres;
                    this.infoObj.id_number = res.num;
                    this.cardAUrl = res.url;
                    this.infoObj.id_card_front = res.url;
                    this.uploadCardASuccess = true;
                }
            } catch (error) {
                this.cardALoad = false;
                this.$toast(error.message||'请求失败');
            }
            

        },
        async uploadIdCardB(e){
            const imgFile = e.target.files[0];
            const formData = new FormData();
            formData.append('file', imgFile);
            this.cardBLoad = true;
            try {
                const res = await this.$http.post('/api/user/uploadIdCard',formData);
                this.cardBLoad = false;
                if(res){
                    this.cardBUrl = res.url;
                    this.infoObj.id_card_backend = res.url;
                    this.uploadCardBSuccess = true;
                }
            } catch (error) {
                this.cardBLoad = false;
                this.$toast(error.message||'请求失败');
            }
        },

    },
}
</script>
<style lang="scss" scoped>
@import '../../assets/user.scss';
.content{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .img-list{
        width:230px;
        img{
            width:100%;
            margin-bottom: 10px;
        }
    }
    .id-info{
        width:100%;
        padding-left: 15px;
        .item{
            margin-bottom: 15px;
            span{
                display: inline-block;
                vertical-align: middle;
            }
            .title{
                text-align: right;
                width: 75px;
            }
            .ver-info{
                width: 146px;
                height: 30px;
                line-height: 28px;
                border: 1px solid #999;
                border-radius: 2px;
                margin-left: 5px;
                padding-left: 5px;
                color: #999;
                font-size: 13px;
            }
        }
    }
}
</style>
